import { QueryParamsEntities } from "@/domain/entities/MainApp";

export class BonusKomisiDetailRequest {
  startDate = "";
  endDate = "";

  constructor(fields?: Partial<BonusKomisiDetailRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}
